import { Button } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";
import GenericModal from "./GenericModal";
import { useEffect, useState, isValidElement, cloneElement } from "react";
import { GenericModalButtonProps } from "../Utils/Types";
import genericStyles from "../Styles/genericStyles.module.css";

export default function ModalButton(props: GenericModalButtonProps) {
  const {
    buttonTitle,
    modalTitle,
    modalSubtitle,
    saveAction,
    content,
    buttonIcon,
    buttonColor,
    formId,
    buttonSize,
    triggerOnClose,
    fullWidth,
  } = props;
  const [open, setOpen] = useState(false);

  /**
   * Handles the closing of the modal by setting the open state to false.
   */
  const onClose = () => {
    setOpen(false);
  };

  /**
   * Creates a chained onClose callback that calls both the original content's onClose
   * and the modal's onClose function.
   */
  const getChainedOnClose = () => {
    if (formId && isValidElement(content)) {
      const originalOnClose = (content.props as any)?.onClose;
      if (originalOnClose && typeof originalOnClose === 'function') {
        return () => {
          originalOnClose();
          onClose();
        };
      }
    }
    return onClose;
  };

  useEffect(() => {
    onClose();
  }, [triggerOnClose]);

  return (
    <>
      <Button
        size={buttonSize ?? "small"}
        variant="contained"
        color={buttonColor ?? "primary"}
        startIcon={buttonIcon}
        style={{ color: "white" }}
        fullWidth={fullWidth}
        onClick={() => setOpen(true)}
      >
        {buttonTitle}
      </Button>
      <GenericModal
        open={open}
        onClose={onClose}
        title={modalTitle ?? buttonTitle}
        otherOptions={modalSubtitle}
        width="800px"
        actions={
          <div className={genericStyles.modalActions}>
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={onClose}
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              form={formId}
              fullWidth
              color="primary"
              variant="contained"
              type={formId ? "submit" : "button"}
              onClick={
                formId
                  ? undefined
                  : async () => {
                      if (saveAction) {
                        const result = await saveAction();
                        if (result === false) {
                          return;
                        }
                        onClose();
                      } else {
                        onClose();
                      }
                    }
              }
            >
              {Vocabulary.save}
            </Button>
          </div>
        }
        children={
          <div className={genericStyles.genericModal}>
            {formId && isValidElement(content)
              ? cloneElement(content, { onClose: getChainedOnClose() } as any)
              : content}
          </div>
        }
      />
    </>
  );
}
